import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import OrderIcon from '../../../../common/icons/orderIcon';
import CourierIcon from '../../../../common/icons/courierIcon';
import DeliveredIcon from '../../../../common/icons/deliveredIcon';
import OrderGettingReadyIcon from '../../../../common/icons/orderGettingReadyIcon';
import ReadyPickupIcon from '../../../../common/icons/readyPickupIcon';
import ConfirmedOrder from '../../../../common/icons/confirmedOrder';
import NotConfirmedOrderIcon from '../../../../common/icons/notConfirmedOrderIcon';
import AlertIcon from '../../../../common/icons/alertIcon';
import RefundIcon from '../../../../common/icons/refundIcon';
import ReadyToDispatchIcon from '../../../../common/icons/readyToDispatchIcon';
import StoreIcon from '../../../../common/icons/storeIcon';
import ErrorOrderStoreIcon from '../../../../common/icons/errorOrderStoreIcon';
import ErrorOCIcon from '../../../../common/icons/errorOcIcon';
import { useColorlibStepIconStyles } from './styles';

const colorPicker = (active, failed) => {
  if (active && !failed) return 'white';
  return '#464646';
};

const iconsKeysFormat = (icons) => {
  const iconsFormat = {};

  Object.entries(icons).forEach(([key, value]) => {
    return (iconsFormat[key.split(' ').join('').toUpperCase()] = value);
  });

  return iconsFormat;
};

const ColorlibStepIcon = ({ ...props }) => {
  const { active, completed, label, failed } = props;
  const classes = useColorlibStepIconStyles({ failed });

  const icons = {
    'Recibimos tu pedido': (
      <OrderIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'Pedido confirmado': (
      <ConfirmedOrder color={colorPicker(active, failed)} size="28px" />
    ),
    'Preparando Producto': (
      <OrderGettingReadyIcon color={colorPicker(active, failed)} size="28px" />
    ),
    '¡Tu pedido está listo!': (
      <ReadyPickupIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'Listo para Retirar': (
      <ReadyPickupIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'Producto Listo para Retirar': (
      <ReadyPickupIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'Pedido entregado': (
      <DeliveredIcon
        color={colorPicker(active, failed)}
        size="32px"
        fontWeight={700}
      />
    ),
    'Listo para enviar': (
      <CourierIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'Pedido en camino a Tambo': (
      <CourierIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'Producto no confirmado': (
      <NotConfirmedOrderIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'Pedido anulado': (
      <AlertIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'En proceso de reembolso': (
      <RefundIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'Pedido en proceso': (
      <OrderGettingReadyIcon color={colorPicker(active, failed)} size="28px" />
    ),
    '¡Vamos en camino!': (
      <CourierIcon color={colorPicker(active, failed)} size="28px" />
    ),
    '¡Tu pedido llegó!': (
      <DeliveredIcon
        color={colorPicker(active, failed)}
        size="32px"
        fontWeight={700}
      />
    ),
    'Creación Orden de Compra': (
      <OrderIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'En tránsito': (
      <CourierIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'En transito a sucursal Correos de Chile': (
      <CourierIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'Envio en tránsito': (
      <CourierIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'En tránsito a tienda': (
      <CourierIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'Entregado en domicilio': (
      <DeliveredIcon
        color={colorPicker(active, failed)}
        size="32px"
        fontWeight={600}
      />
    ),
    'Producto Retirado': (
      <DeliveredIcon
        color={colorPicker(active, failed)}
        size="32px"
        fontWeight={600}
      />
    ),
    Retirado: (
      <DeliveredIcon
        color={colorPicker(active, failed)}
        size="32px"
        fontWeight={600}
      />
    ),
    'Retirado por transportista': (
      <CourierIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'Listo para despachar': (
      <ReadyToDispatchIcon color={colorPicker(active, failed)} size="28px" />
    ),
    Reembolsado: <AlertIcon color={colorPicker(active, failed)} size="28px" />,
    Devuelto: <AlertIcon color={colorPicker(active, failed)} size="28px" />,
    'Reservando Producto en Tienda': (
      <StoreIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'Inconveniente en la orden': (
      <ErrorOCIcon color={colorPicker(active, failed)} size="28px" />
    ),
    'Producto no disponible en tienda': (
      <ErrorOrderStoreIcon color={colorPicker(active, failed)} size="28px" />
    ),
  };

  const iconsFormat = iconsKeysFormat(icons);

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {iconsFormat[label.split(' ').join('').toUpperCase()]}
    </div>
  );
};

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.string,
  label: PropTypes.string,
  failed: PropTypes.bool,
};

export default ColorlibStepIcon;
